import { useEffect } from 'react';
import { base44 } from '@/api/base44Client';

// Emits `booking_link_click` (with page_url) for any click on a Fresha link and
// tags the link with UTM parameters just before the browser follows it.
// One delegated listener covers every Fresha CTA on every page.
const addUtm = (anchor) => {
  const url = new URL(anchor.href);
  // pId marks the visit as coming from the salon's OWN channel (not Fresha marketplace discovery)
  if (!url.searchParams.get('pId')) url.searchParams.set('pId', '770996');
  url.searchParams.set('utm_source', 'ikonomakis.gr');
  url.searchParams.set('utm_medium', 'website');
  url.searchParams.set('utm_campaign', 'booking');
  url.searchParams.set('utm_content', window.location.pathname);
  anchor.href = url.toString();
};

export default function BookingClickTracker() {
  useEffect(() => {
    // mousedown/auxclick/contextmenu: tag before middle-click, new-tab or copy-link
    const onPointer = (e) => {
      const anchor = e.target?.closest?.('a[href*="fresha.com"]');
      if (anchor) addUtm(anchor);
    };
    const onClick = (e) => {
      const anchor = e.target?.closest?.('a[href*="fresha.com"]');
      if (!anchor) return;
      addUtm(anchor);
      const page_url = window.location.pathname;
      base44.analytics.track({ eventName: 'booking_link_click', properties: { page_url } });
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'booking_link_click', { link_url: anchor.href, page_path: page_url });
      }
    };
    document.addEventListener('mousedown', onPointer, true);
    document.addEventListener('touchstart', onPointer, { capture: true, passive: true });
    document.addEventListener('contextmenu', onPointer, true);
    document.addEventListener('click', onClick, true);
    return () => {
      document.removeEventListener('mousedown', onPointer, true);
      document.removeEventListener('touchstart', onPointer, { capture: true });
      document.removeEventListener('contextmenu', onPointer, true);
      document.removeEventListener('click', onClick, true);
    };
  }, []);

  return null;
}